export default __webpack_public_path__ + "static/media/alarm2.8682954f.mp3";